import React from 'react'
import { getData } from 'country-list'
import Select from 'components/Common/Form/Input/Select'
const countries = getData()

interface Props {
  name: string
  defaultValue?: App.Tours.TailorMadeTourRequest['contactCountry']
}

function TailorMadeTourHomeCountryInput({ name, defaultValue }: Props) {
  return <Select
    name={name}
    defaultValue={defaultValue}
    label="Your home country"
    placeholder="Select country"
    required
  >
    {countries.map((country) => <option key={country.code} value={country.code}>{country.name}</option>)}
  </Select>
}

export default TailorMadeTourHomeCountryInput
